<template>
  <div>
    <div class="title-container">
      <div class="line"></div>
      <span class="title"> 商家入驻</span>
    </div>
    <div class="step-class">
      <el-steps :active="1" align-center style="text-align: left;">
        <el-step title="实名认证"></el-step>
        <el-step title="填写店铺信息"></el-step>
        <el-step title="提交审核"></el-step>
      </el-steps>
    </div>
    <!-- 表单区域 -->
    <div>
      <el-form ref="shopForm" :model="shopForm" :rules="formRules" label-width="150px" class="shop-form">
        <!-- 店铺名称 -->
        <el-form-item label="店铺名称" prop="shopName">
          <el-input v-model="shopForm.shopName" placeholder="请填写" />
        </el-form-item>
        <!-- 店铺LOGO -->
        <div style="display: flex; align-items: center;">
          <el-form-item label="店铺LOGO" prop="shopLogo">
            <image-upload :image-url="shopForm.shopLogo" default-image="" @upload-success="handleImgUpload(1, $event)"
              :max-files="1" />
          </el-form-item>
          <el-form-item label="店铺背景" prop="shopBackground">
            <image-upload :image-url="shopForm.shopBackground" @upload-success="handleImgUpload(2, $event)"
              :max-files="1" />
          </el-form-item>
        </div>
        
        <el-form-item label="经营方式" prop="operationMode" style="text-align: left;">
          <el-radio-group v-model="shopForm.operationMode">
            <el-radio label="2">自营</el-radio>
            <el-radio label="1">非自营</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 主营行业 -->
        <el-form-item label="主营行业" prop="mainIndustry">
          <el-select v-model="shopForm.mainIndustry" placeholder="请选择" style="width: 100%">
            <el-option v-for="item in industryList" :key="item.aid" :label="item.name" :value="item.aid" />
          </el-select>
        </el-form-item>
        <!-- 店铺所在地 -->
        <el-form-item label="店铺所在地" prop="shopLocation">
          <div class="location-container">
            <el-input v-model="shopForm.shopLocation" placeholder="点击选择地图位置" readonly
              suffix-icon="el-icon-location" />
            <el-button type="primary" size="small" @click="openMapPicker" style="margin-left: 10px;">
              选择地图位置
            </el-button>
          </div>
        </el-form-item>
        <!-- 店铺详细地址 -->
        <el-form-item label="店铺详细地址" prop="shopAddress">
          <el-input v-model="shopForm.shopAddress" type="textarea" :rows="3" placeholder="请填写" />
        </el-form-item>
        <!-- 店铺简介 -->
        <el-form-item label="店铺简介" prop="shopIntroduction">
          <el-input v-model="shopForm.shopIntroduction" type="textarea" placeholder="请填写" />
        </el-form-item>
        <!-- 经营资质 -->
        <el-form-item label="经营资质" prop="qualifications">
          <ImageUpload ref="imageUpload" :image-url="shopForm.qualifications" :max-files="6" @upload-success="handleUploadSuccess" />
        </el-form-item>
        <!-- 按钮区域 -->
        <el-form-item class="button-group">
          <el-button @click="goBack">上一步</el-button>
          <el-button type="primary" @click="submitForm">提交</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 地图选点弹窗 -->
    <el-dialog title="地图选点" :visible.sync="mapPickerVisible" width="80%" height="80vh"
      :before-close="handleMapPickerClose" :close-on-click-modal="false">
      <MapPicker ref="mapPicker" @pointConfirmed="handleMapConfirm" :center="initMapLngLat" />
    </el-dialog>
  </div>
</template>

<script>
import MapPicker from '@/components/MapPicker.vue'
import ImageUpload from '@/components/ImageUpload.vue'
export default {
  name: 'ShopAuthentication',
  components: { ImageUpload, MapPicker },
  props: {
    certified: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      // 表单数据
      shopForm: {
        shopName: '',
        shopLogo: '',
        shopBackground: '',
        operationMode: '2',
        mainIndustry: '',
        shopLocation: '',
        shopAddress: '',
        shopIntroduction: '',
        qualifications: []
      },
      // 地图选点弹窗可见性
      mapPickerVisible: false,
      // 初始地图经纬度
      initMapLngLat: [116.397428, 39.90923],
      // 选中的地图信息
      selectedMapInfo: {
        adcode: "",
        city: "",
        cityCode: "",
        district: "",
        districtCode: "",
        formattedAddress: "",
        lat: "",
        lng: "",
        province: "",
        provinceCode: ""
      },

      formRules: {
        shopName: [
          { required: true, message: '请填写店铺名称', trigger: 'blur' },
          { min: 2, max: 50, message: '店铺名称长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        shopBackground: [
          { required: true, message: '请上传店铺背景', trigger: 'change' }
        ],
        operationMode: [
          { required: true, message: '请选择经营方式', trigger: 'change' }
        ],
        mainIndustry: [
          { required: true, message: '请选择主营行业', trigger: 'change' }
        ],
        shopLocation: [
          { required: true, message: '请选择店铺所在地', trigger: 'change' }
        ],
        shopAddress: [
          { required: true, message: '请填写店铺详细地址', trigger: 'blur' }
        ],
        shopIntroduction: [
          { required: true, message: '请填写店铺简介', trigger: 'blur' }
        ],
        qualifications: [
          { required: true, message: '请上传经营资质', trigger: 'change' },
          { type: 'array', min: 1, message: '至少上传1张经营资质图片', trigger: 'change' },
          { type: 'array', max: 6, message: '最多上传6张经营资质图片', trigger: 'change' }
        ],
      },
      industryList: [],//主营行业列表
    }
  },

  mounted() {
    this.getIndustryList();
    if (this.certified === '3') {
      this.getShopInfo();
    }
  },

  methods: {
    getShopInfo() {
      this.$api.getShopReviewInfo().then(res => {
        this.shopForm.shopName = res.store_name;
        this.shopForm.shopLogo = res.store_logo;
        this.shopForm.shopBackground = res.store_backdrop;
        this.shopForm.operationMode = res.run_type_id;
        this.shopForm.mainIndustry = res.main_industry;
        this.shopForm.shopLocation = res.store_province_name + res.store_city_name + res.store_district_name;
        this.shopForm.shopAddress = res.store_address;
        this.shopForm.shopIntroduction = res.store_introduce;
        this.selectedMapInfo.lng =res.lng;
        this.selectedMapInfo.lat =res.lat;
        this.selectedMapInfo.provinceCode = res.store_province_id;
        this.selectedMapInfo.cityCode = res.store_city_id;
        this.selectedMapInfo.districtCode = res.store_district_id;
        this.selectedMapInfo.province = res.store_province_name;
        this.selectedMapInfo.city = res.store_city_name;
        this.selectedMapInfo.district = res.store_district_name;
        this.shopForm.qualifications = res.shop_qualifications;
        console.log(this.shopForm.qualifications);
      }).catch(err => {
        this.$message.warning(err)
      })
    },
    getIndustryList() {
      this.$api.getIndustryList().then(res => {
        this.industryList = res;
      }).catch(err => {
        this.$message.warning(err)
      })
    },
    handleImgUpload(index, imageUrl) {
      if (index === 1) {
        this.shopForm.shopLogo = imageUrl[0];
        this.$refs.shopForm.validateField('shopLogo');
      } else if (index === 2) {
        this.shopForm.shopBackground = imageUrl[0];
        this.$refs.shopForm.validateField('shopBackground');
      }
    },
    handleUploadSuccess(images) {
      this.shopForm.qualifications = images;
      this.$refs.shopForm.validateField('qualifications');
      console.log('上传成功的图片:', images);
    },
    // 返回上一步
    goBack() {
       this.$emit('goToComponent', 'ShopAuthentication');
    },
    // 打开地图选点弹窗
    openMapPicker() {
      this.mapPickerVisible = true;
    },
    // 处理地图选点确认
    handleMapConfirm(selectedInfo) {
      this.mapPickerVisible = false;
      this.shopForm.shopLocation = selectedInfo.formattedAddress;
      this.selectedMapInfo = selectedInfo;
    },
    // 处理地图选点弹窗关闭
    handleMapPickerClose() {
      this.mapPickerVisible = false;
    },
    // 提交表单
    submitForm() {
      this.$refs.shopForm.validate((valid) => {
        if (valid) {
          this.$api.submitShopInfo({
            store_name: this.shopForm.shopName,
            store_logo: this.shopForm.shopLogo,
            store_backdrop: this.shopForm.shopBackground,
            store_address: this.shopForm.shopAddress,
            run_type: this.shopForm.operationMode,
            main_industry: this.shopForm.mainIndustry,
            store_introduce: this.shopForm.shopIntroduction,
            shop_qualifications: this.shopForm.qualifications.join(','),
            lng: this.selectedMapInfo.lng || '',
            lat: this.selectedMapInfo.lat || '',
            store_province_id: this.selectedMapInfo.provinceCode || '',
            store_province_name: this.selectedMapInfo.province || '',
            store_city_id: this.selectedMapInfo.cityCode || '',
            store_city_name: this.selectedMapInfo.city || '',
            store_district_id: this.selectedMapInfo.districtCode || '',
            store_district_name: this.selectedMapInfo.district || '',
          }).then(res => {
            this.$message.success('店铺信息提交成功');
            this.$emit('goToComponent', 'ShopWaiting', { certified: '1' });
          }).catch(err => {
            this.$message.warning(err)
          })
        } else {
          this.$message.error('请填写完整店铺信息');
          return false;
        }
      });
    }
  }
};
</script>

<style scoped>
.step-class {
  width: 100%;
  margin: 32px 0;
}

.shop-authentication-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 30px 20px;
}

.page-title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
  text-align: left;
  /* 修改为左对齐 */
}

.steps-indicator {
  margin-bottom: 40px;
  text-align: left;
  /* 确保步骤指示器左对齐 */
}

.form-container {
  background-color: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);
}

.shop-form .el-form-item {
  margin-bottom: 25px;
}

.shop-form .el-upload--picture-card {
  width: 100px;
  height: 100px;
}

.shop-form .el-upload-list__item {
  margin-right: 10px;
  margin-bottom: 10px;
}

.button-group {
  display: flex;
  justify-content: flex-start;
  /* 修改为左对齐 */
  margin-top: 40px;
}

.button-group .el-button {
  width: 120px;
  margin: 0 10px 0 0;
  /* 调整按钮间距，只保留右侧间距 */
}

.line {
  width: 3px;
  height: 18px;
  background-color: #286CED;
}

.title-container {
  display: flex;
  align-items: center;
}

.title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-left: 10px;
}

/* 地图选点相关样式 */
.location-container {
  display: flex;
  align-items: center;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .shop-authentication-container {
    padding: 20px 10px;
  }

  .form-container {
    padding: 20px;
  }

  .shop-form .el-form-item {
    margin-bottom: 20px;
  }

  .location-container {
    flex-direction: column;
    align-items: flex-start;
  }

  .location-container .el-button {
    margin-left: 0;
    margin-top: 10px;
  }
}
</style>